<script>
import Button from "@/components/atoms/button";

export default {
  name: "ShippingMethodLcInfosService",
  components: {
    Button
  },
  props: {
    service: {
      type: Object,
      required: true
    },
    tarifMini: {
      type: String,
      required: false,
      default: null
    }
  },
  emits: ["openPopinTarifsYper"]
};
</script>

<template>
  <div>
    <p class="u-font-700 u-mb-xs">
      {{ service.label }}
    </p>
    <p v-if="tarifMini">
      {{ tarifMini }} en fonction des conditions d’éligibilité géographique
    </p>
    <p v-if="service.checkout.montant_max">
      Disponible pour les commandes inférieures à {{ formatPrix(service.checkout.montant_max) }}€
    </p>
    <Button
      link
      variant="text-light"
      @click="$emit('openPopinTarifsYper')"
    >
      Voir les tarifs
    </Button>
  </div>
</template>
